import { render, staticRenderFns } from "./CaseTransferMediaButton.vue?vue&type=template&id=78e67e88&scoped=true"
import script from "./CaseTransferMediaButton.vue?vue&type=script&lang=js"
export * from "./CaseTransferMediaButton.vue?vue&type=script&lang=js"
import style0 from "./CaseTransferMediaButton.vue?vue&type=style&index=0&id=78e67e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e67e88",
  null
  
)

export default component.exports